import axios from 'axios';
import qs from 'qs';
import { authInterceptor, logout } from './auth-interceptor';

const apiVersion = '/api_ats/v1';

export const http = axios.create({
  baseURL: `${apiVersion}`,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    },
  },
});

http.interceptors.response.use(
  (result) => {
    if (
      typeof result === 'object' &&
      result !== null &&
      'config' in result &&
      result.config?.fullResponse
    ) {
      return result;
    }
    return result.data;
  },
  (error) => {
    // Handle error responses
    if (error.config?.fullResponse && error.response) {
      // Return the full error response instead of throwing
      return Promise.reject(error.response);
    }
    // For other errors, throw as usual
    return Promise.reject(error);
  }
);

authInterceptor(http, {
  getAccessToken: () => {
    return localStorage.getItem('apiv1Auth');
  },

  shouldLogout: (error) => {
    const { config, response: { data = {} } = {} } = error;
    return (
      config.url !== '/auth' &&
      ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some((err) =>
        data?.errors?.includes?.(err)
      )
    );
  },

  shouldRefresh: (error) => {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return false;
    }
    const data = error?.response?.data || {};
    if (
      Array.isArray(data.errors) &&
      data.errors.includes('err_token_expired')
    ) {
      return true;
    }
    return false;
  },

  logout: logout,
});
